import React, { useState, useEffect } from 'react';
import {
  Box, Drawer, IconButton, Typography, useMediaQuery, useTheme
} from '@mui/material';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import AddIcon from '@mui/icons-material/Add';
import ExploreIcon from '@mui/icons-material/Explore';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import axios from 'axios';
import ScheduleIcon from '@mui/icons-material/Schedule';
import VideoCallIcon from '@mui/icons-material/VideoCall';
import EventIcon from '@mui/icons-material/Event';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import PsychologyIcon from '@mui/icons-material/Psychology';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import ExpertsPage from '../Expert/ExpertsPage';
import SchoolIcon from '@mui/icons-material/School';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';



const API_URL = process.env.REACT_APP_API_URL;

const Platform = ({ onLogout }) => {
  const [isVerified, setIsVerified] = useState(false);
  const [hoveredItem, setHoveredItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { userId } = useAuth();
  const { role, roles } = useAuth();

// const userRoles = Array.isArray(roles) && roles.length > 0 ? roles : [role];
// ✅ SAFE — parse the string, fall back to single role
const userRoles = (() => {
  let parsedRoles = [];

  if (Array.isArray(roles)) {
    parsedRoles = roles;
  } else if (typeof roles === "string") {
    try {
      const parsed = JSON.parse(roles);
      parsedRoles = Array.isArray(parsed) ? parsed : [roles];
    } catch {
      parsedRoles = [roles];
    }
  }

  // ✅ Merge with single role
  if (role && !parsedRoles.includes(role)) {
    parsedRoles.push(role);
  }

  return parsedRoles;
})();
console.log("roles:", roles);
console.log("role:", role);
console.log("userRoles:", userRoles);


  
  // const userRole = localStorage.getItem('role');

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // e.g., sm = 600px

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  // useEffect(() => {
  // if (role === 'expert' || role === 'admin' || role === 'anthra-sales-executive') {
  //     setIsVerified(true);
  //   }  
  //   }, [role]);

  useEffect(() => {
  const verifiedRoles = ['expert', 'admin', 'anthra-sales-executive'];

  if (verifiedRoles.some(r => userRoles.includes(r))) {
    setIsVerified(true);
  }
}, [userRoles]);


  // useEffect(() => {
  //   const checkVerification = async () => {
  //     if (!userId) return;

  //     try {
  //       const response = await axios.post(`${API_URL}/api/check-verification/`, {
  //         user_id: userId,
  //       });
  //       setIsVerified(response.data.status === 'approved');
  //     } catch (error) {
  //       console.error('Verification check failed:', error);
  //       setIsVerified(false);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   checkVerification();
  // }, [userId]);

  // const sidebarOptions = [
  //   { text: 'Create', icon: <AddIcon />, route: 'create' },
  //   { text: 'Explore', icon: <ExploreIcon />, route: 'recommended' },
  //   {
  //     text: isVerified ? 'Hostings' : 'My Requests',
  //     icon: <EventIcon />,
  //     route: isVerified ? 'my-hosts' : 'my-requests',
  //   },
  //   {
  //     text: isVerified ? 'Accepted' : 'My Bookings',
  //     icon: <LiveTvIcon />,
  //     route: isVerified ? 'accepted' : 'bookings',
  //   },
  // ];
  const isHostingUser = userRoles.some(r =>
  ['expert', 'admin', 'anthra-sales-executive'].includes(r)
);


  const sidebarOptions = [
  // Show "Create" only if verified
  ...(isVerified
    ? [{
        text: 'Create',
        icon: <AddIcon />,
        route: 'create',
      }]
    : []),
    // ...(isVerified
    // ? [{
    //     text: 'Create Series',
    //     icon: <PlaylistAddIcon />,
    //     route: 'create-series',
    //   }]
    // : []),

  // Show "Explore" only if NOT verified
  // { text: 'Sessions', icon: <ExploreIcon />, route: 'explore' },

   ...(isVerified
    ? [{
        text: 'Sesssions',
        icon: <ExploreIcon />,
        route: 'explore',
      }]
    : []),

 

 {
    text: isHostingUser ? 'Hostings' : 'Appointment',
    icon: <EventIcon />,
    route: isHostingUser ? 'my-hosts' : 'bookings',
  },

  // Show "My Bookings" only if NOT verified
// {
//         text: 'My Bookings',
//         icon: <LiveTvIcon />,
//         route: 'bookings',
//       },

      // {
      //   text: 'Ask Expert',
      //   icon: <PsychologyIcon sx={{ color: '#f37208ff' }} />,
      //   route: 'ask-expert',
      //   isDirect: true,
      // },
//       {
//   text: 'Ask Expert',
//   icon: (
//     <PsychologyIcon 
//       sx={{ 
//         transform: 'scaleX(-1)'  
//       }} 
//     />
//   ),
//   route: 'ask-expert',
//   isDirect: true,
// },
{
  text: 'Ask Expert',
  icon: (
    <PsychologyIcon 
      sx={{ 
        transform: 'scaleX(-1)'  
      }} 
    />
  ),
  route: 'chatbot',
  isDirect: true,
},

//  {
//   text: 'Experts',
//   icon: (
//     <VerifiedUserIcon  />
//   ),
//   route: 'experts',
//   isDirect: true,
// }
 ...(isVerified
    ? [{
        text: 'Experts',
        icon: <VerifiedUserIcon />,
        route: 'experts',
        isDirect:true,
      }]
    : []),

];


  const drawerWidth = 60;
  const drawerHeight = 60;

  const drawerStyle = {
    width: isMobile ? '100%' : drawerWidth,
    height: isMobile ? drawerHeight : '100%',
    boxSizing: 'border-box',
    backgroundColor: '#000000',
    borderTop: isMobile ? '1px solid #333' : 'none',
    borderRight: isMobile ? 'none' : '1px solid #000000',
    pt: isMobile ? 0 : 8,
    display: 'flex',
    flexDirection: isMobile ? 'row' : 'column',
    alignItems: 'center',
    justifyContent: isMobile ? 'space-around' : 'flex-start',
  };

  return (
    <Drawer
      variant="permanent"
      anchor={isMobile ? 'bottom' : 'left'}
      sx={{
        width: isMobile ? '100%' : drawerWidth,
        height: isMobile ? drawerHeight : '1vh',
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: drawerStyle,
      }}
    >
      {sidebarOptions.map((option) => (
        // <Link
        //   to={`/platform/${option.route}`}
        //   key={option.text}
        //   style={{ textDecoration: 'none' }}
        // >
          <Link
          to={option.isDirect ? `/${option.route}` : `/platform/${option.route}`}
          key={option.text}
          style={{ textDecoration: 'none' }}
        >
          <Box
            onMouseEnter={() => setHoveredItem(option.text)}
            onMouseLeave={() => setHoveredItem(null)}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              py: isMobile ? 0 : 2,
              px: isMobile ? 2 : 0,
              '&:hover .text': {
                visibility: 'visible',
                opacity: 1,
              },
            }}
          >
            {/* <IconButton
              sx={{
                color: hoveredItem === option.text ? '#1E90FF' : 'white',
                transition: 'color 0.3s ease',
              }}
            > */}
             <IconButton
              sx={{
    color: hoveredItem === option.text ? '#1E90FF' : 'white',
    transition: 'color 0.3s ease',
  }}
            >
              {option.icon}
            </IconButton>
            {!isMobile && (
              <Typography
                className="text"
  //               sx={{
  //   fontSize: '0.7rem',
  //   color: hoveredItem === option.text ? '#1E90FF' : 'white',
  //   visibility: 'hidden',
  //   opacity: 0,
  //   transition: 'opacity 0.3s ease',
  //   textAlign: 'center',
  // }}
  sx={{
  fontSize: '0.7rem',
  color: hoveredItem === option.text ? '#1E90FF' : 'white',
  visibility: 'hidden',
  opacity: 0,
  transition: 'opacity 0.3s ease',
  textAlign: 'center',

  maxWidth: '60px',          // ✅ restrict width
  whiteSpace: 'normal',      // ✅ allow wrap
  wordBreak: 'break-word',   // ✅ break long words
  lineHeight: '1rem',        // ✅ better spacing
}}
              >
            
                {option.text}
              </Typography>
            )}
          </Box>
        </Link>
      ))}
    </Drawer>
  );
};

export default Platform;
